export const PAGE_ROUTES = {
    NewDeals: '/event/new-deals',
    LeavingSoon: '/event/last-chance-deals',
    ForYou: '/event/for-you',
    MyLounge: '/event/:categoryTabId?',
    ErrorPage: '/error-page',
};
